import { CharacterPack } from "./types";
import { characterPacks } from "./character-packs";
import { GroupOrder, GroupOrderMember } from "@lemmonhq/types";

/**
 * Get the character pack by name
 */
export function getCharacterPackByName(
  name: string | null,
): CharacterPack | null {
  if (!name) return null;
  return characterPacks.find((pack) => pack.name === name) || null;
}

/**
 * Get a random character pack
 */
export function getRandomCharacterPack(): CharacterPack {
  return characterPacks[Math.floor(Math.random() * characterPacks.length)];
}

/**
 * Get display name for a customer based on their rank in the group order
 * @param groupOrder The group order containing members
 * @param customerId The customer ID to get the display name for
 * @returns The member display name, or null if customer not found
 */
export function getCharacterNameForCustomer(
  groupOrder: GroupOrder,
  customerId: string,
): string | null {
  if (!groupOrder.members) {
    return null;
  }

  // Sort members by created_at to get consistent ordering
  const sortedMembers = [...groupOrder.members].sort((a, b) => {
    return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
  });

  // Find the index of the customer
  const memberIndex = sortedMembers.findIndex(
    (member) => member.customer_id === customerId,
  );

  if (memberIndex === -1) {
    return null;
  }

  return `Member ${memberIndex + 1}`;
}

/**
 * Get all members with their assigned character names
 */
export function getMembersWithCharacters(
  groupOrder: GroupOrder,
): Array<GroupOrderMember & { characterName: string | null }> {
  return groupOrder.members.map((member) => ({
    ...member,
    characterName: getCharacterNameForCustomer(groupOrder, member.customer_id),
  }));
}
